import { render, staticRenderFns } from "./SolicitorListing.vue?vue&type=template&id=c28828a6"
import script from "./SolicitorListing.vue?vue&type=script&lang=js"
export * from "./SolicitorListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports